/*
 * Bits shared between the two Systems layouts (Services and
 * ServicesFullbleed). Kept here so a change to how status is expressed lands
 * in both at once — the statuses are the honest part of that section and must
 * never drift between layouts.
 */

/*
 * Three states, and the distinction matters:
 *   live    - we run it in production today
 *   build   - we are building it, on ourselves, right now
 *   offered - we build it to order; we do not run a version of it
 * Only `live` gets the filled accent treatment. Nothing else should read as
 * a running system at a glance.
 */
export const STATUS_STYLES = {
  live:    { label: 'In production',  solid: true,  accent: true  },
  build:   { label: 'In build',       solid: false, accent: true  },
  offered: { label: 'Built to order', solid: false, accent: false },
};

export function StatusPill({ status, size = 'sm' }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.offered;
  const color = s.accent ? 'var(--fa-signal)' : 'var(--fa-muted)';
  const lg = size === 'lg';
  return (
    <span
      className="fa-ref inline-flex items-center gap-1.5"
      style={{
        fontSize: lg ? 9.5 : 8.5,
        padding: lg ? '5px 11px' : '4px 9px',
        borderRadius: 3,
        border: `1px ${s.solid ? 'solid' : 'dashed'} ${color}`,
        color,
        background: s.solid ? 'var(--fa-signal-wash)' : 'transparent',
      }}
    >
      <span
        className={`fa-status-dot ${status === 'live' ? 'fa-status-dot--live' : 'fa-status-dot--dev'}`}
        style={{ width: 5, height: 5, boxShadow: 'none', borderColor: color }}
        aria-hidden="true"
      />
      {s.label}
    </span>
  );
}

export function ToolChips({ tools, size = 'sm' }) {
  const lg = size === 'lg';
  return (
    <div>
      <span className="fa-label" style={{ color: 'var(--fa-muted)' }}>Plugs into</span>
      <div className="flex flex-wrap gap-1.5 mt-2.5">
        {tools.map((t) => (
          <span
            key={t}
            className="fa-ref"
            style={{
              fontSize: lg ? 10 : 9,
              padding: lg ? '5px 11px' : '4px 9px',
              borderRadius: 3,
              border: '1px solid var(--fa-rule)',
              background: 'var(--fa-paper)',
              color: 'var(--fa-ink)',
              textTransform: 'none',
              letterSpacing: '0.03em',
            }}
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
